import { GetServerSideProps } from 'next';

import {
  getArticleMetaBySlug,
  InsightArticleMeta,
} from '@klokhuis/modules/Commons/pages/RealEstateInsights/articles';
import { ArticleDetailPage } from '@klokhuis/modules/Commons/pages/RealEstateInsights/ArticleDetail.page';

export { ArticleDetailPage as default };

export const getServerSideProps: GetServerSideProps<{
  meta: InsightArticleMeta;
}> = async ({ params }) => {
  const slug = params?.slug as string;
  const meta = getArticleMetaBySlug(slug);
  if (!meta) return { notFound: true };
  return { props: { meta } };
};
